import module from 'contabilidad/polizas/module.js'
import * as moment from 'moment'

const schema = {
  data: {
    Captura_Fecha: 'data',
    Importe: 'number',
    ImpDiv: 'number',
    Comple: 'number',
  },
}

const cadA = 'P  AAAAMMDD    2      JJJJ 1 0          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n'
const cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' + '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n'
const padEnd = (string, length) => string.substring(0, length).padEnd(length)

export class ContabilidadPolizasDeudoresDiversosService {
  constructor ($http, $filter) {
    this.$http = $http
    this.$filter = $filter
  }

  get (fechaInicio, fechaFin, idOperadora, idsEmpresas) {
    return this.$http.get('/kendu/contabilidad/polizas/deudoresdiversos', {
      params: {
        fecha_inicio: moment(fechaInicio).format('YYYY-MM-DD'),
        fecha_fin: moment(fechaFin).format('YYYY-MM-DD'),
        id_operadora: idOperadora,
        ids_empresas: idsEmpresas,
      },
      schema,
    })
  }

  codificar (data, inicioPoliza) {
    try {
      return data.reduce((contenido, item) => {
        let fechaA = moment(item.Fecha_Movimiento).format('YYYYMMDD')
        let fechaB = item.Banco_Referencia.indexOf('a') > 0 ? moment(item.Fecha_Movimiento).format('DD/MM/YYYY') : item.Banco_Referencia
        contenido += cadA
          .replace('AAAAMMDD', fechaA)
          .replace('JJJJ', ('000' + inicioPoliza).slice(-4))
          .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', padEnd(item.Descripcion, 60))

        contenido += cadB
          .replace('CCCCCCCCCCCCCCCC', padEnd(item.Cuenta_Contable.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', padEnd(fechaB, 15))
          .replace('*', '1')
          .replace('YYYYYYYYY', padEnd(item.TotalBanco.toFixed(2), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd(item.Descripcion, 43))

        if (item.Tipo_Moneda === '2') {
          contenido += cadB
            .replace('CCCCCCCCCCCCCCCC', padEnd(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', padEnd(fechaB, 15))
            .replace('*', '1')
            .replace('YYYYYYYYY', padEnd(item.TotalComple.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd(item.Descripcion, 43))
        }

        item.cuentas.forEach((ele) => {
          contenido += cadB
            .replace('CCCCCCCCCCCCCCCC', padEnd(('1070060' + ('000' + item.ID_Empresa).slice(-3) + '000000'), 16))
            .replace('ZZZZZZZZZZZZZZZ', padEnd(fechaB, 15))
            .replace('*', '0')
            .replace('YYYYYYYYY', padEnd(((item.Tipo_Moneda === '2' ? ele.ImpDiv : ele.Importe)).toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', padEnd((ele.Descripcion + ' ' + ele.Notas), 43))
        })

        inicioPoliza++

        return contenido
      }, '')
    } catch (err) {
      return 'Error'
    }
  }
}

module.service('ContabilidadPolizasDeudoresDiversos', ContabilidadPolizasDeudoresDiversosService)



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/Polizas/DeudoresDiversos.js